import styled from 'styled-components/macro';
import { Button, Icon } from '~/components';

export const CloseButtonIcon = styled(Icon)`
  margin-left: 11px;
`;

export const PlayerHeader = styled.div`
  position: relative;
  height: 263px;
  background-color: ${({ theme }) => theme.white};
  > div:nth-child(2) {
    position: relative;
    display: flex;
    color: ${({ isLocal, theme }) => (isLocal ? theme.dark : theme.white)};
    width: 100%;
    height: 100%;
    padding: 20px 20px 0;
    z-index: 2;
    align-items: flex-end;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    height: auto;
  }
`;

export const ShieldBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  background-image: url(${({ bgImage }) => bgImage});
  background-repeat: no-repeat;
  background-position: calc(100% - 41px) calc(100% - -112px);
  filter: grayscale(100%);
  background-size: 350px;
  opacity: 0.3;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    background-size: 270px;
    background-position: calc(100% + 80px) center;
  }
`;

export const PlayerHeaderImage = styled.img`
  margin-right: 34px;
  object-fit: contain;
  object-position: bottom;
  max-width: 39%;
  width: 186px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    margin-right: 0px;
    height: 160px;
    width: 145px;
  }
`;

export const CloseButton = styled(Button)`
  position: absolute;
  top: 27px;
  right: 27px;
  background: none;
  border: none;
  color: ${({ theme, isLocal }) => (isLocal ? theme.black : theme.white)};
  font-size: 13px;
  font-weight: bold;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  &:hover svg {
    transform: rotateZ(90deg);
  }
  svg {
    transition: transform 0.2s;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    left: 15px;
    right: auto;
    top: 15px;
  }
`;

export const CloseButtonText = styled.span`
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    display: none;
  }
`;

export const PlayerHeaderInfo = styled.div`
  display: flex;
  padding-bottom: 30px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    flex-direction: column;
    padding-bottom: 13px;
    flex-grow: 1;
    padding-right: 6px;
    align-items: flex-end;
  }
`;

export const PlayerHeaderInfoNum = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  align-items: flex-end;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    justify-content: end;
  }
`;
export const PlayerNumber = styled.div`
  font-size: 72px;
  line-height: 53px;
  margin-top: 13px;
  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 50px;
    margin-top: 0px;
  }
`;
export const PlayerHeaderInfoName = styled.div`
  padding: 0px 20px;
  position: relative;
  top: 25px;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    text-align: right;
    padding: 0px;
  }
`;
export const PlayerName = styled.span`
  display: block;
  font-size: 16px;
  font-weight: 300;
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 13px;
    margin-top: 7px;
  }
`;
export const PlayerNickname = styled.span`
  display: block;
  font-size: 40px;
  font-weight: 500;
  line-height: 1.2;

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    font-size: 28px;
  }
`;
